import { Field } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { CheckBoxGroup, CheckBox } from 'common/components/forms';
import { useLocalization } from 'redux/localization/utils/hooks';

const AgeVerification = () => {
  const setting = useSelector((state) => state.setting.data);
  const { t } = useLocalization();

  return (
    <CheckBoxGroup
      label={t('general.address.ageVerification')}
      labelSROnly
      name="customerConfirmedAge"
    >
      <Field
        name="customerConfirmedAge"
        label={t('general.address.ageConfirmation', {
          age: setting.minimumAge
        })}
        component={CheckBox}
        dataTestId="age-verification-checkbox"
      />
    </CheckBoxGroup>
  );
};

export default AgeVerification;
